<header class="pt-topbar header header--library">
  <div class="container pt-5 pt-xl-6 position-relative">
    <header class="row mb-4 mb-lg-5 header__content px-sm-3 px-lg-0">
      <div class="col-md-10 col-lg-12">
        @if (header().subtitle) {
          <strong class="fs-body-sm fw-normal d-inline-block mb-3 lh-1">{{ header().subtitle }}</strong>
        }
        @if (header().title) {
          <h2 class="h2">{{ header().title }}</h2>
        }
      </div>

      @if (header().intro; as text) {
        <div class="col-md-14 col-lg-12">
          <div
            class="markdown-content"
            fstrDynamicContent
            [innerHTML]="text | resizeHtmlImages | stripEmbed: cookiePreferences() | safe"
          ></div>

          @if (header().button?.url || header().secondaryButton?.url) {
            <div class="d-flex flex-wrap mt-3 gap-1 header-actions">
              @if (header().button?.url) {
                <fstr-link [button]="header().button!" [cssClasses]="'button button--light button--sm'"></fstr-link>
              }

              @if (header().secondaryButton?.url) {
                <fstr-link [button]="header().secondaryButton!" [cssClasses]="'button button--light button--sm'"></fstr-link>
              }
            </div>
          }
        </div>
      }
    </header>

    <ul class="row header__gallery gutter-x-2 mx-n4 mx-lg-n5">
      @for (image of randomImages(); track image.url) {
        <li class="col-12 col-sm-{{ 24 / randomImages().length }} d-flex">
          <img
            class="mt-auto"
            [class.tall]="$index % 2"
            [ngSrc]="image?.url || 'https://coda.fstr.io/media/placeholder.png'"
            [width]="600"
            [height]="$index % 2 ? 700 : 600"
            [alt]="image?.alt || image?.caption"
            ngSrcset="550w, 800w"
            [loaderParams]="{
              width: 600,
              height: $index % 2 ? 700 : 600,
              anchor: image?.anchor || 'middlecenter',
              scale: 'both',
            }"
            [attr.data-object-position]="image?.anchor || 'middlecenter'"
            [priority]="true"
          />
        </li>
      }
    </ul>

    <div class="header__search mx-2 mx-md-auto">
      <ng-content></ng-content>
    </div>
  </div>
</header>
